import { RESPONSE_MODES, type ResponseMode } from '@/shared-responder-v2-core';

/** Nullish counts as enabled, matching the manager's own convention. */
export const DEFAULT_PROJECT_CAN_JUMP_FORWARD = true;

export const DEFAULT_PROJECT_INTERACTION_TYPE: ResponseMode =
  RESPONSE_MODES.Text;

/**
 * `QuestionV2Model.connectionRules` exists in the schema and is a real
 * "does this question branch" signal, but selecting it here forced picking a
 * shape for every rule field a step further down (`activationType`,
 * `postActivationActionType`, …) than this adapter needs just to detect
 * presence — and a minimal `{ id }` selection collides with `FormQuestion`
 * (`libs/survey-import`), which structurally expects the fuller shape on the
 * same field name from a different query. Rather than widen the selection to
 * fix an unrelated consumer, `hasBranching` stays `false` here: the kernel
 * never evaluates a rule client-side anyway (`nextQuestionId` from the
 * backend is the sole routing authority, `BE-REQUIREMENTS-RESPONDER.md` §6),
 * so the only cost of understating it is a jump-forward barrier that could
 * be tighter than necessary — never a wrong answer. Revisit by selecting
 * `connectionRules { id }` once `FormQuestion` no longer collides.
 */
export const DEFAULT_QUESTION_HAS_BRANCHING = false;
